import { Component, OnInit } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SignUpService } from 'src/app/services/sign-up.service';
import { UserService } from 'src/app/services/user.service';
import { CountryService } from 'src/app/services/country.service';
import { AlertService } from 'src/app/utilities/alert.service';
import { Country } from 'src/app/models';
import { Stylist } from 'src/app/models';
import { Salon } from 'src/app/models';
import { StylistService } from 'src/app/services/stylist.service';
import { StylistEmailChecker } from 'src/app/utilities/stylist-email-checker';
import { CustomValidator } from 'src/app/utilities/custom-validator';
import { Utilities } from '../utilities/utilities';
import { AlertController, LoadingController, NavController, Platform } from '@ionic/angular';
import { List } from 'immutable';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

declare let gtag: Function;
declare var posthog: any;
declare let fbq: Function;
declare var posthog: any;
declare var rewardful: any;
declare var Rewardful: any;
declare global {
  interface Window {
    lintrk: any;
  }
}
export interface IAuth {
  salon: any;
  token: string;
  user: any;
}
export interface IReferral {
  referralCode: string;
  affiliateID: string;
  affiliateToken: string;
}
@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  public isLoading: boolean;

  public errorOccurredWhileLoadingCountries: boolean;

  public submitAttempt: boolean;

  public registerInfoForm: UntypedFormGroup;

  public countries: List<Country>;

  public timeZones: Array<{ text: string; value: string }>;

  public salonName: UntypedFormControl;

  public country: UntypedFormControl;

  public timeZone: UntypedFormControl;

  public planID: number = 2;

  public firstName: UntypedFormControl;

  public lastName: UntypedFormControl;
  public phoneNumber: UntypedFormControl;

  public email: UntypedFormControl;

  public password: UntypedFormControl;

  public showPassword: boolean = false;

  public showSalonProfile: boolean = false;

  public firstNameSelected: boolean = false;
  public lastNameSelected: boolean = false;
  public phoneNumberSelected: boolean = false;
  public emailSelected: boolean = false;
  public passwordSelected: boolean = false;
  public salonNameSelected: boolean = false;
  public rewardfulAffiliateToken: string = '';
  public rewardfulAffiliateID: string = '';
  public rewardfulReferralID: string = '';

  constructor(
    private platform: Platform,
    private inAppBrowser: InAppBrowser,
    private stylistService: StylistService,
    private stylistEmailChecker: StylistEmailChecker,
    private userService: UserService,
    private signUpService: SignUpService,
    private alertCtrl: AlertController,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private countryService: CountryService,
    private navCtrl: NavController,
  ) {
    this.isLoading = false;
    this.submitAttempt = false;
    this.countries = List([]);
    this.timeZones = Utilities.getTimeZones().toArray();

    this.salonName = new UntypedFormControl('', Validators.compose([Validators.required]));

    // TODO: detect user's country and timezone
    let userCountry: number = 124;
    let userTimeZone: string = 'America/Los_Angeles';

    this.country = new UntypedFormControl(
      userCountry,
      Validators.compose([Validators.required])
    );
    this.timeZone = new UntypedFormControl(
      userTimeZone,
      Validators.compose([Validators.required])
    );
    this.submitAttempt = false;
    this.stylistService.setEmailCheckerStylistID(undefined);
    this.firstName = new UntypedFormControl(null!, {
      validators: Validators.compose([Validators.required, Validators.maxLength(30)])
    });

    this.lastName = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.maxLength(35)])
    });
    this.phoneNumber = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.maxLength(12)])
    });

    this.email = new UntypedFormControl('', {
      validators: [Validators.required, CustomValidator.validateEmail]
    });

    this.password = new UntypedFormControl('', {
      validators: Validators.compose([Validators.required, Validators.maxLength(70)])
    });

    this.registerInfoForm = new UntypedFormGroup({
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      email: this.email,
      password: this.password,
      salonName: this.salonName,
      country: this.country,
      timeZone: this.timeZone,
    });

    posthog.capture('Signup page: Visited');

  }


  ngOnInit() {
    this.loadCountries();
    rewardful("ready", () => {
      if (Rewardful.referral) {
        this.rewardfulReferralID = Rewardful.referral;
        this.rewardfulAffiliateID = Rewardful.affiliate.id;
        this.rewardfulAffiliateToken = Rewardful.affiliate.token;
      } else {
        console.log("No referral present.");
      }
    });
  }

  firstNameFocus() {
    this.firstName.setValidators(
      Validators.compose([Validators.required, Validators.maxLength(30)])
    );
  }

  lastNameFocus() {
    this.lastName.setValidators(
      Validators.compose([Validators.required, Validators.maxLength(35)])
    );
  }
  phoneNumberFocus() {
    this.phoneNumber.setValidators(
      Validators.compose([Validators.required, Validators.maxLength(12)])
    );
  }

  emailFocus() {
    this.email.setValidators(
      Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        CustomValidator.validateEmail,
      ])
    );
    this.email.setAsyncValidators(
      this.stylistEmailChecker.stylistEmailAvailabilityChecker()
    );
  }

  passwordFocus() {
    this.password.setValidators(
      Validators.compose([Validators.required, Validators.maxLength(70)])
    );
  }

  // passwordConfirmFocus() {
  //   this.password2.setValidators(
  //     Validators.compose([Validators.required, Validators.maxLength(70)])
  //   );
  // }

  businessNameFocus() {
    this.salonName.setValidators(
      Validators.compose([Validators.required, Validators.maxLength(100)])
    );
  }

  public loadCountries() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingCountries = false;
    this.countryService.getCountries().subscribe({
      next: (countries) => {
        this.countries = countries;
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.presentErrorAlert();
        this.isLoading = false;
        this.errorOccurredWhileLoadingCountries = true;
      },
      complete: () => console.info('Fetched all countries'),
    });
  }

  public async onSalonInfoFormSave() {
    this.submitAttempt = true;
    this.salonNameSelected = true;
    gtag('config', 'G-MFKK9R8PZ9', { 'page_path': 'app/SignupPage2' });
    posthog.capture('Trial signup completed', {
      businessName: this.salonName.value,
      country: this.country.value,
      timeZone: this.timeZone.value,
    });

    if (!this.registerInfoForm.valid) {
      return;
    }

    const country: Country = this.countries
      .filter((country: Country) => country.id === this.country.value)
      .toList()
      .first();
    const salon: Salon = new Salon({
      id: undefined,
      subDomain: undefined,
      salonName: this.salonName.value,
      calStartTime: '09:00',
      calEndTime: '17:00',
      appVersion: 8,
      website: undefined,
      address1: undefined,
      address2: undefined,
      phone: undefined,
      fax: undefined,
      city: undefined,
      province: undefined,
      postal: undefined,
      cancellationPolicy: undefined,
      email: this.email.value,
      readOnly: 0,
      timeZone: this.timeZone.value,
      planID: this.planID ? this.planID : 5,
      accountStatus: undefined,
      creationDate: new Date(),
      sameSocialMediaLinksForAllStaff: undefined,
      trialLength: undefined,
      country: country,
      referralCodeUsed: undefined,
      analytics: undefined,
      currency: undefined,
      currencyID: undefined,
      enablePOS: undefined,
      onboarding: undefined,
      chargifyID: undefined,
      chargifyCurrency: undefined,
      chargifyStatus: undefined,
      sameCancellationPolicyForAllStaff: undefined,
      sameCustomizedEmailsForAllStaff: undefined,
      stripeUserID: undefined,
    });

    const stylist: Stylist = new Stylist({
      id: undefined,
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      title: undefined,
      email: this.email.value,
      phone1: this.phoneNumber.value,
      phone2: undefined,
      address1: undefined,
      address2: undefined,
      city: undefined,
      province: undefined,
      postal: undefined,
      country: undefined,
      active: undefined,
      administrator: undefined,
      isRebook: undefined,
      suggestRebookingBeforeCheckout: undefined,
      stylistKey: undefined,
      confirmApptsManually: undefined,
      calendar: undefined,
      viewAllCalendars: undefined,
      viewAllClients: undefined,
      photoUrl: undefined,
      hideDurations: undefined,
      canPush: undefined,
      settingsControl: undefined,
      canViewReports: undefined,
      cc: undefined,
      allowBookingsUntil: undefined,
      bookingHorizon: undefined,
      sendAppointmentReminderBefore: undefined,
      bookingInterval: undefined,
      letClientsRegister: undefined,
      letClientsCancel: undefined,
      bookingIntro: undefined,
      notifyForAllStaffActivity: undefined,
      newBookingNotification: undefined,
      editBookingNotification: undefined,
      deleteBookingNotification: undefined,
      waitListRequestNotification: undefined,
      serviceDefinitions: undefined,
      bookings: undefined,
      areServiceDetailsLoaded: undefined,
      cachedServiceDetailsOptionsEl: undefined,
      intercomUserHash: undefined,
      password: this.password.value,
      abTest: undefined,
      fbID: undefined,
      cancellationPolicy: undefined,
      waitingList: undefined,
      allowCancellationUntil: '',
      letClientsUseFBLogin: undefined,
      minCancellation: '',
      sort: undefined,
      pronoun: undefined,
      customPronoun: undefined,
      isChatboxEnabled: true,
      isChatBubbleEnabled: true,
    });

    const referral: IReferral = {
      referralCode: this.rewardfulReferralID,
      affiliateID: this.rewardfulAffiliateID,
      affiliateToken: this.rewardfulAffiliateToken,
    };

    // sign up the user
    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();
    this.signUpService.process(salon, stylist, referral).subscribe({
      next: (auth: IAuth) => {
        loader.dismiss().then(() => {
          this.userService.login(auth);
          // set google tracking
          gtag('config', 'UA-27998627-1', { 'page_path': 'app/SignupComplete' });
          // Google Event snippet for Free Trial Registration conversion page 
          gtag('event', 'conversion', { 'send_to': 'AW-10847902957/qu3ACNPIx88YEO2517Qo' });
          // track signup in Facebook
          fbq('track', 'CompleteRegistration');
          // track signup in posthog
          posthog.capture('Signup')
          //track signup in LinkedIn
          window.lintrk('track', { conversion_id: 7565124 });
          if (this.userService.isLoggedIn()) {
            setTimeout(() => {

              this.navCtrl.navigateRoot("/bookings");
            }, 100);
            return false;
          }
        });
      },
      error: (err) => {
        loader.dismiss().then(async () => {
          const errAlert = await this.alertCtrl.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          errAlert.present();
        });
      },
    });
  }

  public onTermsOfService() {
    const termsOfServiceLink = `https://salonmonster.com/terms-conditions/`;
    if (this.platform.is('capacitor')) {
      this.inAppBrowser.create(termsOfServiceLink, '_system');
    } else {
      window.open(termsOfServiceLink, '_blank').focus();
    }
  }

  public onPrivacyPolicy() {
    const privacyPolicyLink = `https://salonmonster.com/privacy-policy/`;
    if (this.platform.is('capacitor')) {
      this.inAppBrowser.create(privacyPolicyLink, '_system');
    } else {
      window.open(privacyPolicyLink, '_blank').focus();
    }
  }

  switchShowPassword() {
    this.showPassword = !this.showPassword;
  }

  salonProfile() {
    // we are done submitting the initial stylist info, now get the salon info
    this.firstName.markAsTouched();
    this.lastName.markAsTouched();
    this.email.markAsTouched();
    this.password.markAsTouched();
    this.phoneNumber.markAsTouched();
    this.passwordSelected = true;
    this.emailSelected = true;
    this.lastNameSelected = true;
    this.firstNameSelected = true;

    if (
      this.firstName.valid &&
      this.lastName.valid &&
      this.email.valid &&
      this.phoneNumber.valid &&
      this.password.valid
    ) {
      gtag('config', 'G-MFKK9R8PZ9', { 'page_path': 'app/SignupPage1' });
      this.showSalonProfile = !this.showSalonProfile;

      posthog.capture('Signup page: User details submitted', {
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        phone: this.phoneNumber.value,
        email: this.email.value,
      });
    }
  }
}
